module.exports = __webpack_public_path__ + "img/Logos_Powered-By-AutoVerify.6798545f.svg";